export default class ServicoDatahub {
    constructor({ api }) {
        this.api = api;
    }

    obterLista(chave) {
        return this.api
            .get(`/api/datahub/lists/${chave}`)
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                }
                console.log(error);
                throw error;
            });
    }

    obterMapeamento({ mapa, chave }) {
        return this.api
            .get(`/api/datahub/maps/${mapa}?chave=${chave}`)
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                }
                console.log(error);
                throw error;
            });
    }
}
